import React, {useEffect, useState} from 'react';
import TextInput from "../../../ui_components/TextInput/TextInput";
import SearchIcon from '@material-ui/icons/Search';
import {useI18nContext} from "../../../contexts/I18nContext";
import ShippingInputProperties from "./ShippingInputProperties";

const ShippingInput: React.FC<ShippingInputProperties> = ({
                                                          value,
                                                          placeholder,
                                                          onChange,
                                                          disabled,
                                                          fullWidth = false,
                                                          className = '',
                                                          onEnter = () => {
                                                          }
                                                      }) => {

    const [shipping, setShipping] = useState(value);
    const i18n = useI18nContext();

    useEffect(() => {
        setShipping(value);
    }, [value]);


    const onShippingChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const newFilter = event.target.value;
        setShipping(newFilter);
        onChange(newFilter);
    }

    const onKeyPress = (key: string) => {
        if (key === "Enter") {
            onEnter(shipping);
        }
    }

    return (
        <div>
            <div style={{ display: 'flex', alignItems: 'center' }}>

                <TextInput
                    label={i18n.translate("SHIPPING")}
                    value={shipping}
                    placeholder={placeholder}
                    disabled={disabled}
                    onKeyPress={onKeyPress}
                    onChange={onShippingChange}
                    startIcon={SearchIcon}
                    className={className}
                    fullWidth={fullWidth}
                />

            </div>
        </div>
    )
}


export default ShippingInput;
